import React from 'react';
import { useNavigate } from 'react-router-dom';
import apiHooks from '../../../hooks/apiHooks';
import ListDataPage from '../../../components/pages/ListDataPage';
import dayjs from 'dayjs';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import ActionDropdownItems from 'components/common/ActionDropdownItems';
import { deleteSalesService } from '../../../services/salesServiceService';

interface ActionItem {
  eventKey: string;
  label: string;
  type: 'function' | 'redirect'; // Ensure type is restricted
  callback?: () => void;
  url?: string;
  className?: string;
  divider?: boolean;
}

const AllInstitutes = () => {
  const navigate = useNavigate(); // React Router hook for navigation

  // Function to return properly typed actions for each row
  const getActions = (crm_institute_id: string): ActionItem[] => [
    {
      eventKey: '2',
      label: 'Edit',
      type: 'function',
      callback: () =>
        navigate(`/crm/institutes/edit-institutes/${crm_institute_id}`)
    },
    {
      eventKey: '3',
      label: 'Remove',
      type: 'function',
      callback: () => deleteSalesService(crm_institute_id),
      className: 'text-danger'
    },
    {
      eventKey: '3',
      label: 'Add contacts',
      type: 'function',
      callback: () => navigate(`/crm/contacts/add-contacts/${crm_institute_id}`)
    },
    {
      eventKey: '3',
      label: 'View',
      type: 'function',
      callback: () =>
        navigate(`/crm/institutes/institute-details/${crm_institute_id}`)
    },
    {
      eventKey: '3',
      label: 'Add Address',
      type: 'function',
      callback: () =>
        navigate(`/crm/institutes/add-address/${crm_institute_id}`)
    }
  ];

  const columns = [
    { accessorKey: 'crm_institute_id', header: 'Institute ID' },
    { accessorKey: 'institute_name', header: 'Institute Name' },
    { accessorKey: 'status', header: 'Status' },
    {
      accessorKey: 'user',
      header: 'Assigned To',
      cell: ({ row }: { row: any }) => {
        const user = row.original.user;
        return user ? `${user.username} ${user.email} ${user.role}` : 'N/A'; // Handle cases where user data might be missing
      }
    },
    {
      accessorKey: 'created_at',
      header: 'Created At',
      cell: ({ row }: { row: any }) => (
        <span>
          {dayjs(row.original.created_at).format('DD/MM/YYYY HH:mm:ss')}
        </span>
      )
    },
    {
      id: 'action',
      header: 'Actions',
      cell: ({ row }: { row: any }) => (
        <RevealDropdownTrigger style={{ zIndex: '999' }}>
          <RevealDropdown>
            <ActionDropdownItems
              actions={getActions(row.original.crm_institute_id)}
            />
          </RevealDropdown>
        </RevealDropdownTrigger>
      ),
      meta: {
        headerProps: { style: { width: '7%' } },
        cellProps: { className: 'text-center' }
      }
    }
  ];

  return (
    <ListDataPage
      apiHook={apiHooks.useCRMInstitutes}
      entityName="All Institutes"
      columns={columns}
    />
  );
};

export default AllInstitutes;
